export default {
	name: "ArrowButton",
	props: ["title", "icon", "dark_button", "no_margin", "click_handler", "disabled"],
	methods: {},
};
